// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_teaming_candidates.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-493 TEAM-01: our position on a Pursuit and gap-driven teaming candidates.
 * A candidate is a canonical Company proposed against specific
 * capture_solution_gaps with a human-entered rationale. Candidates, capability
 * statements and status events are append-only. Nothing here contacts the
 * company or records an agreement.
 *
 * @generated from message mono.projectdata.v1.CapturePositionCapability
 */ export class CapturePositionCapability extends Message {
    static fromBinary(bytes, options) {
        return new CapturePositionCapability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePositionCapability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePositionCapability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePositionCapability, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * What we can do, in our own words (no shared taxonomy).
   *
   * @generated from field: string statement = 2;
   */ _define_property(this, "statement", ""), /**
   * Required: where the claim comes from.
   *
   * @generated from field: string evidence_label = 3;
   */ _define_property(this, "evidenceLabel", ""), /**
   * @generated from field: string evidence_ref = 4;
   */ _define_property(this, "evidenceRef", ""), /**
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * Optional canonical registry Capability id (delivery.capabilities).
   *
   * @generated from field: string capability_id = 7;
   */ _define_property(this, "capabilityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePositionCapability, "runtime", proto3);
_define_property(CapturePositionCapability, "typeName", "mono.projectdata.v1.CapturePositionCapability");
_define_property(CapturePositionCapability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "evidence_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "evidence_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureTeamingStatusEvent
 */ export class CaptureTeamingStatusEvent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingStatusEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingStatusEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingStatusEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingStatusEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * proposed | under_review | shortlisted | declined
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * Required: why the status changed.
   *
   * @generated from field: string note = 3;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp at = 5;
   */ _define_property(this, "at", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingStatusEvent, "runtime", proto3);
_define_property(CaptureTeamingStatusEvent, "typeName", "mono.projectdata.v1.CaptureTeamingStatusEvent");
_define_property(CaptureTeamingStatusEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureTeamingCandidate
 */ export class CaptureTeamingCandidate extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Canonical Company (delivery.company_profiles) id.
   *
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_name = 3;
   */ _define_property(this, "companyName", ""), /**
   * Required human-entered rationale.
   *
   * @generated from field: string rationale = 4;
   */ _define_property(this, "rationale", ""), /**
   * Optional free-text note on what they bring; never a shared taxonomy.
   *
   * @generated from field: string their_capability = 5;
   */ _define_property(this, "theirCapability", ""), /**
   * At least one capture_solution_gaps id this candidate is proposed against.
   *
   * @generated from field: repeated string gap_ids = 6;
   */ _define_property(this, "gapIds", []), /**
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * Latest status event.
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * Newest first. Retained in full.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingStatusEvent history = 10;
   */ _define_property(this, "history", []), /**
   * SAD-419: complete current assessment and all versions, newest first.
   *
   * @generated from field: mono.projectdata.v1.CaptureTeamingAssessment current_assessment = 11;
   */ _define_property(this, "currentAssessment", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingAssessment assessment_history = 12;
   */ _define_property(this, "assessmentHistory", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingCandidate, "runtime", proto3);
_define_property(CaptureTeamingCandidate, "typeName", "mono.projectdata.v1.CaptureTeamingCandidate");
_define_property(CaptureTeamingCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "their_capability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "gap_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "history",
            kind: "message",
            T: CaptureTeamingStatusEvent,
            repeated: true
        },
        {
            no: 11,
            name: "current_assessment",
            kind: "message",
            T: CaptureTeamingAssessment
        },
        {
            no: 12,
            name: "assessment_history",
            kind: "message",
            T: CaptureTeamingAssessment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureTeamingPositionRequest
 */ export class GetCaptureTeamingPositionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureTeamingPositionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureTeamingPositionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureTeamingPositionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureTeamingPositionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureTeamingPositionRequest, "runtime", proto3);
_define_property(GetCaptureTeamingPositionRequest, "typeName", "mono.projectdata.v1.GetCaptureTeamingPositionRequest");
_define_property(GetCaptureTeamingPositionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureTeamingPositionResponse
 */ export class GetCaptureTeamingPositionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureTeamingPositionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureTeamingPositionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureTeamingPositionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureTeamingPositionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CapturePositionCapability capabilities = 1;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamingCandidate candidates = 2;
   */ _define_property(this, "candidates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureTeamingPositionResponse, "runtime", proto3);
_define_property(GetCaptureTeamingPositionResponse, "typeName", "mono.projectdata.v1.GetCaptureTeamingPositionResponse");
_define_property(GetCaptureTeamingPositionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: CapturePositionCapability,
            repeated: true
        },
        {
            no: 2,
            name: "candidates",
            kind: "message",
            T: CaptureTeamingCandidate,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCapturePositionCapabilityRequest
 */ export class AddCapturePositionCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCapturePositionCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapturePositionCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapturePositionCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapturePositionCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: mono.projectdata.v1.CapturePositionCapability capability = 4;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapturePositionCapabilityRequest, "runtime", proto3);
_define_property(AddCapturePositionCapabilityRequest, "typeName", "mono.projectdata.v1.AddCapturePositionCapabilityRequest");
_define_property(AddCapturePositionCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "capability",
            kind: "message",
            T: CapturePositionCapability
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCapturePositionCapabilityResponse
 */ export class AddCapturePositionCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCapturePositionCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapturePositionCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapturePositionCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapturePositionCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CapturePositionCapability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapturePositionCapabilityResponse, "runtime", proto3);
_define_property(AddCapturePositionCapabilityResponse, "typeName", "mono.projectdata.v1.AddCapturePositionCapabilityResponse");
_define_property(AddCapturePositionCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: CapturePositionCapability
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposeCaptureTeamingCandidateRequest
 */ export class ProposeCaptureTeamingCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeCaptureTeamingCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeCaptureTeamingCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeCaptureTeamingCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeCaptureTeamingCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string rationale = 5;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string their_capability = 6;
   */ _define_property(this, "theirCapability", ""), /**
   * @generated from field: repeated string gap_ids = 7;
   */ _define_property(this, "gapIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeCaptureTeamingCandidateRequest, "runtime", proto3);
_define_property(ProposeCaptureTeamingCandidateRequest, "typeName", "mono.projectdata.v1.ProposeCaptureTeamingCandidateRequest");
_define_property(ProposeCaptureTeamingCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "their_capability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "gap_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposeCaptureTeamingCandidateResponse
 */ export class ProposeCaptureTeamingCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeCaptureTeamingCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeCaptureTeamingCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeCaptureTeamingCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeCaptureTeamingCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingCandidate candidate = 1;
   */ _define_property(this, "candidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeCaptureTeamingCandidateResponse, "runtime", proto3);
_define_property(ProposeCaptureTeamingCandidateResponse, "typeName", "mono.projectdata.v1.ProposeCaptureTeamingCandidateResponse");
_define_property(ProposeCaptureTeamingCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate",
            kind: "message",
            T: CaptureTeamingCandidate
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamingCandidateStatusRequest
 */ export class SetCaptureTeamingCandidateStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamingCandidateStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamingCandidateStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamingCandidateStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamingCandidateStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string candidate_id = 4;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamingCandidateStatusRequest, "runtime", proto3);
_define_property(SetCaptureTeamingCandidateStatusRequest, "typeName", "mono.projectdata.v1.SetCaptureTeamingCandidateStatusRequest");
_define_property(SetCaptureTeamingCandidateStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamingCandidateStatusResponse
 */ export class SetCaptureTeamingCandidateStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamingCandidateStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamingCandidateStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamingCandidateStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamingCandidateStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingCandidate candidate = 1;
   */ _define_property(this, "candidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamingCandidateStatusResponse, "runtime", proto3);
_define_property(SetCaptureTeamingCandidateStatusResponse, "typeName", "mono.projectdata.v1.SetCaptureTeamingCandidateStatusResponse");
_define_property(SetCaptureTeamingCandidateStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate",
            kind: "message",
            T: CaptureTeamingCandidate
        }
    ]));
/**
 * Immutable substance, separate from candidate status and agreement lifecycle.
 *
 * @generated from message mono.projectdata.v1.CaptureTeamingAssessment
 */ export class CaptureTeamingAssessment extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string candidate_id = 4;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string company_profile_id = 5;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string request_id = 6;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int32 version = 7;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string supersedes_id = 8;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: string rationale = 9;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string their_capability = 10;
   */ _define_property(this, "theirCapability", ""), /**
   * @generated from field: repeated string gap_ids = 11;
   */ _define_property(this, "gapIds", []), /**
   * Source references stored as text: opaque IDs (e.g. Touchpoints), document
   * locators or HTTP(S) URLs. Nonblank and free of control characters; not fetched.
   *
   * @generated from field: repeated string evidence_refs = 12;
   */ _define_property(this, "evidenceRefs", []), /**
   * Optional revision reason, retained when supplied.
   *
   * @generated from field: string reason = 13;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string actor_user_id = 14;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingAssessment, "runtime", proto3);
_define_property(CaptureTeamingAssessment, "typeName", "mono.projectdata.v1.CaptureTeamingAssessment");
_define_property(CaptureTeamingAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "their_capability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "gap_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "evidence_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Explicit human action only. Supply the complete replacement and the current
 * assessment ID. Identical retries return the same version; changed retries or
 * stale predecessors fail with AlreadyExists. Actor comes from the principal.
 *
 * @generated from message mono.projectdata.v1.ReviseCaptureTeamingAssessmentRequest
 */ export class ReviseCaptureTeamingAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCaptureTeamingAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCaptureTeamingAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCaptureTeamingAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCaptureTeamingAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string candidate_id = 4;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string predecessor_id = 5;
   */ _define_property(this, "predecessorId", ""), /**
   * @generated from field: string company_profile_id = 6;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string their_capability = 8;
   */ _define_property(this, "theirCapability", ""), /**
   * @generated from field: repeated string gap_ids = 9;
   */ _define_property(this, "gapIds", []), /**
   * Optional revision reason, retained when supplied.
   *
   * @generated from field: string reason = 10;
   */ _define_property(this, "reason", ""), /**
   * Same source-reference contract as CaptureTeamingAssessment.evidence_refs.
   *
   * @generated from field: repeated string evidence_refs = 11;
   */ _define_property(this, "evidenceRefs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCaptureTeamingAssessmentRequest, "runtime", proto3);
_define_property(ReviseCaptureTeamingAssessmentRequest, "typeName", "mono.projectdata.v1.ReviseCaptureTeamingAssessmentRequest");
_define_property(ReviseCaptureTeamingAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "predecessor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "their_capability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "gap_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "evidence_refs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviseCaptureTeamingAssessmentResponse
 */ export class ReviseCaptureTeamingAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCaptureTeamingAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCaptureTeamingAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCaptureTeamingAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCaptureTeamingAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamingAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCaptureTeamingAssessmentResponse, "runtime", proto3);
_define_property(ReviseCaptureTeamingAssessmentResponse, "typeName", "mono.projectdata.v1.ReviseCaptureTeamingAssessmentResponse");
_define_property(ReviseCaptureTeamingAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: CaptureTeamingAssessment
        }
    ]));
